import { Component } from '@angular/core';

@Component({
  selector: 'common-image-icon',
  templateUrl: './image-icon.component.svg',
  styleUrls: ['./image-icon.component.scss'],
})
export class ImageIconComponent {}
